import { Enum } from "./Enum";

export const EErrorCode = Object.freeze({
  404: "404",
  500: "500",
});

export type EErrorCode = Enum<typeof EErrorCode>;
